module.exports = __webpack_public_path__ + "static/media/csr_background.187f72b3.png";